import { render, staticRenderFns } from "./address.vue?vue&type=template&id=78455059&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"
import style0 from "./address.vue?vue&type=style&index=0&id=78455059&prod&lang=scss"
import style1 from "./address.vue?vue&type=style&index=1&id=78455059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78455059",
  null
  
)

export default component.exports